<div class="data-table-container">
  <p-table
    [value]="config?.keepOrder ? data : getSortedData()"
    [paginator]="config.paginator !== false"
    [rows]="rows"
    [first]="first"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="false"
    [loading]="loading"
    loadingIcon="pi pi-spin pi-spinner fast-spinner"
    (onPage)="onPageChange($event)"
    class="custom-table">

    <ng-template pTemplate="header">
      <tr>
        <th *ngIf="config.selectable"
            [attr.rowspan]="hasHeaderGroups ? 2 : 1"
            style="width: 50px;"
            [class.has-colspan]="hasColspan"
        >
          <p-checkbox
            [(ngModel)]="selectAll"
            (onChange)="onSelectAllToggle()">
          </p-checkbox>
        </th>

        <!-- first header row: parent headers or leaf headers (with rowspan when no children) -->
        <ng-container *ngFor="let col of columns">
          <th *ngIf="!col.children || col.children.length === 0"
              [style.width]="col.width"
              [pSortableColumn]="col.sortable === true ? col.field : undefined"
              [class.sortable-header]="col.sortable === true"
              [attr.rowspan]="hasHeaderGroups ? 2 : null"
              [attr.colspan]="col.colspan ? col.colspan : null"
              [class.has-colspan]="hasColspan"          >
            {{ col.header | translate }}
            <div [style.color]="'var(--table-header-text)'" class="header-subtitle">
              {{ $any(col?.headerSubtitle) | translate }}
            </div>
            <p-sortIcon *ngIf="col.sortable === true" [field]="col.field"></p-sortIcon>
          </th>

          <th *ngIf="col.children && col.children.length > 0"
              [attr.colspan]="col.children.length"
              [attr.rowspan]="col.rowspan ? col.rowspan : null"
              class="parent-header">
            {{ col.header | translate }}
            <div [style.color]="'var(--table-header-text)'" class="header-subtitle">
              {{$any(col?.headerSubtitle) | translate}}
            </div>
          </th>
        </ng-container>
      </tr>

      <!-- second header row: children -->
      <tr *ngIf="hasHeaderGroups">
        <ng-container *ngFor="let col of columns">
          <ng-container *ngIf="col.children && col.children.length > 0">
            <th *ngFor="let child of col.children"
                [style.width]="child.width"
                [pSortableColumn]="child.sortable === true ? child.field : undefined"
                [class.sortable-header]="child.sortable === true"
                [class.has-colspan]="hasColspan"
            >
              {{ child.header | translate }}
              <div [style.color]="'var(--table-header-text)'" class="header-subtitle">
                {{ $any(child?.headerSubtitle) | translate }}
              </div>
              <p-sortIcon *ngIf="child.sortable === true" [field]="child.field"></p-sortIcon>
            </th>
          </ng-container>
          <!-- leaf parent previously rendered as rowspan in the first row; nothing needed here -->
        </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
      <tr (click)="onRowClickChange(row)" [class.clickable-row]="config.selectable">
        <td *ngIf="config.selectable">
          <p-checkbox
            [(ngModel)]="row.selected"
            (onChange)="onRowSelectChange(row)">
          </p-checkbox>
        </td>

        <!-- body rendering: for each column, render either single cell or cells for each child -->
        <ng-container *ngFor="let col of columns">
          <ng-container *ngIf="col.children && col.children.length > 0; else leafCell">
            <td *ngFor="let child of col.children" [style.width]="child.width">
              <span *ngIf="child.parseFunction">{{ formatCellText(getCellValue(row, child)) }}</span>
              <ng-container *ngIf="!child.parseFunction" [ngSwitch]="child.type">
                <span *ngSwitchCase="'text'" [title]="formatCellText(row[child.field])">{{ formatCellText(row[child.field]) }}</span>
                <span *ngSwitchCase="'date'">{{ formatDate(row[child.field]) }}</span>
                <span *ngSwitchCase="'double'" class="text-align-right">{{ row[child.field] | msfNumber:  tr.currentLang }}</span>
                <span *ngSwitchCase="'number'" class="text-align-right">{{ row[child.field]}}</span>
                <span *ngSwitchCase="'localizationString'">{{ getLocalizedValue(row, child.field) }}</span>
                <span *ngSwitchCase="'badge'" class="badge"
                      [ngClass]="child.badgeClass ? child.badgeClass(row[child.field]) : ''">
              {{ row[child.field] | translate }}
            </span>
                <span *ngSwitchCase="'boolean'">
              <i class="pi" [ngClass]="row[child.field] ? 'pi-check text-success' : 'pi-times text-danger'"></i>
            </span>
                <div *ngSwitchCase="'actions'" class="action-buttons">
                  <button *ngFor="let action of config.actions | slice:0:1" pButton type="button"
                          [icon]="action.icon" [class]="action.class || 'p-button-text p-button-sm'"
                          [pTooltip]="action.tooltip ? (action.tooltip | translate) : ''" tooltipPosition="top"
                          [style.display]="isActionVisible(action, row) ? 'inline-flex' : 'none'"
                          (click)="executeAction(action, row); $event.stopPropagation()">
                  </button>
                </div>
                <ng-container *ngSwitchCase="'custom'">
                  <ng-container
                    *ngTemplateOutlet="child.customTemplate; context: { $implicit: row, rowIndex: rowIndex, fieldName: child.field }"></ng-container>
                </ng-container>
                <span *ngSwitchDefault>{{ formatCellText(getCellValue(row, child)) }}</span>
              </ng-container>
            </td>
          </ng-container>

          <ng-template #leafCell>
            <td [style.width]="col.width">
              <span *ngIf="col.parseFunction">{{ formatCellText(getCellValue(row, col)) }}</span>
              <ng-container *ngIf="!col.parseFunction" [ngSwitch]="col.type">
                <span *ngSwitchCase="'text'" [title]="formatCellText(row[col.field])">{{ formatCellText(row[col.field]) }}</span>
                <span *ngSwitchCase="'date'">{{ formatDate(row[col.field]) }}</span>
                <span *ngSwitchCase="'double'" class="text-align-right">{{ row[col.field] | msfNumber:  tr.currentLang}}</span>
                <span *ngSwitchCase="'number'" class="text-align-right">{{ row[col.field]}}</span>
                <span *ngSwitchCase="'localizationString'">{{ getLocalizedValue(row, col.field) }}</span>
                <span *ngSwitchCase="'badge'" class="badge"
                      [ngClass]="col.badgeClass ? col.badgeClass(row[col.field]) : ''">
              {{ row[col.field] | translate }}
            </span>
                <span *ngSwitchCase="'boolean'">
              <i class="pi" [ngClass]="row[col.field] ? 'pi-check text-success' : 'pi-times text-danger'"></i>
            </span>
                <div *ngSwitchCase="'actions'" class="action-buttons">
                  <button *ngFor="let action of config.actions | slice:0:1" pButton type="button"
                          [icon]="action.icon" [class]="action.class || 'p-button-text p-button-sm'"
                          [pTooltip]="action.tooltip ? (action.tooltip | translate) : ''" tooltipPosition="top"
                          [style.display]="isActionVisible(action, row) ? 'inline-flex' : 'none'"
                          (click)="executeAction(action, row); $event.stopPropagation()">
                  </button>
                </div>
                <ng-container *ngSwitchCase="'custom'">
                  <ng-container
                    *ngTemplateOutlet="col.customTemplate; context: { $implicit: row, rowIndex: rowIndex, fieldName: col.field }"></ng-container>
                </ng-container>
                <span *ngSwitchDefault>{{ formatCellText(getCellValue(row, col)) }}</span>
              </ng-container>
            </td>
          </ng-template>
        </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="config.selectable ? leafColumnCount + 1 : leafColumnCount" class="empty-message">
          {{ ('No data found' | translate) }}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="paginatorleft">
      <div class="paginator-left-container">
        <div class="total-records">{{ 'Total' | translate }}: {{ totalRecords }}</div>

        <div class="page-size-selector">
          <select [(ngModel)]="rows" (change)="onPageChange({first: 0, rows: rows})" class="rows-per-page">
            <option *ngFor="let option of config.rowsPerPageOptions || [10, 25, 50, 100]" [value]="option">
              {{ option }}
            </option>
          </select>
        </div>
      </div>
    </ng-template>
  </p-table>
</div>
